<div #captureRoot class="conflicts-dialog">
  <mat-icon class="close-btn screenshot-exclude" (click)="close()">close</mat-icon>

  <div class="screenshot-target">
    <div class="capture-header">
      <mat-icon>warning_amber</mat-icon>
      <div>
        <h2>Conflicts Found</h2>
        <p>{{ conflicts.length }} conflict(s) between uploaded file and existing data.</p>
      </div>
    </div>

    <div class="table-wrap">
      <table class="conflicts-table">
        <thead>
          <tr>
            <th>Tank</th>
            <th>Parameter</th>
            <th>Date</th>
            <th>DB Value</th>
            <th>Incoming Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of conflicts">
            <td>{{ formatTank(row.tank) }}</td>
            <td>{{ formatParameter(row.field) }}</td>
            <td>{{ formatDate(row.date) }}</td>
            <td>{{ formatValue(row.db_value) }}</td>
            <td class="incoming-value">{{ formatValue(row.incoming_value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="footer-hint">
      Switch to <strong>Force Insert</strong> in the upload popup to overwrite conflicting values.
    </p>
  </div>

  <div class="dialog-actions screenshot-exclude">
    <button
      class="btn screenshot-btn"
      type="button"
      (click)="copyScreenshot()"
      [disabled]="isCapturing">
      <mat-icon>{{ isCapturing ? 'hourglass_top' : 'photo_camera' }}</mat-icon>
      {{ isCapturing ? 'Copying...' : 'Screenshot' }}
    </button>
    <button class="btn close-dialog-btn" type="button" (click)="close()">Close</button>
  </div>
</div>
